import * as React from "react";
import SaveDialogLayout from "components/DialogLayout/SaveDialogLayout";
import repository from "client/repository";
import {DataBaseComponent, DataBaseComponentState} from "components/DataBaseComponent";
import {Text} from "components/form";
import {ProvisionOutboundPrivateLinkRequest} from "client/resources/provisionOutboundPrivateLinkRequest";

interface Props {
    instanceId: string;
    initialAlias?: string;
    onTaskStarted: (taskId: string) => void;
}

interface State extends DataBaseComponentState {
    request: ProvisionOutboundPrivateLinkRequest;
}

class ProvisionOutboundPrivateLinkDialog extends DataBaseComponent<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            request: {
                PrivateLinkServiceAlias: props.initialAlias || "",
                RequestMessage: ""
            }
        };
    }

    render() {
        return <SaveDialogLayout title={"Provision Outbound Private Link"}
            onSaveClick={() => this.provision()}
            errors={this.state.errors}
            saveButtonLabel={"Provision"}
            busy={this.state.busy}>
            <Text label="Private Link Service Alias"
                value={this.state.request.PrivateLinkServiceAlias}
                onChange={PrivateLinkServiceAlias => this.modifyRequestState({PrivateLinkServiceAlias})}
            />
            <Text label="Request Message"
                value={this.state.request.RequestMessage}
                onChange={RequestMessage => this.modifyRequestState({RequestMessage})}
            />
        </SaveDialogLayout>;
    }

    private modifyRequestState(request: Partial<ProvisionOutboundPrivateLinkRequest>): void {
        this.setState((prevState: State) => ({request: {...prevState.request, ...request}}));
    }

    private async provision(): Promise<boolean> {
        return await this.doBusyTask(async () => {
            const taskId = await repository.HostedInstances.provisionOutboundPrivateLink(this.props.instanceId, this.state.request);
            this.props.onTaskStarted(taskId);
        });
    }
}

export default ProvisionOutboundPrivateLinkDialog;
